module.exports = __webpack_public_path__ + "img/outlined-filter.6fd267a9.svg";